import { render, staticRenderFns } from "./editRole.vue?vue&type=template&id=a1f01416&"
import script from "./editRole.vue?vue&type=script&lang=ts&"
export * from "./editRole.vue?vue&type=script&lang=ts&"
import style0 from "./editRole.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports